
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","fill":"none"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.823 3.46L9.34.093c1.063-.42 2.112.638 1.683 1.697L7.61 10.218c-.484 1.195-2.223 1.033-2.479-.23l-.683-3.373-3.4-.671C-.225 5.692-.384 3.936.823 3.459zM9.634.837L1.117 4.203c-.465.184-.403.86.086.956l3.596.71a.5.5 0 01.393.392l.723 3.569a.5.5 0 00.954.088l3.413-8.427a.5.5 0 00-.648-.653z","fill":"#282830"}})])
      }
    
      }
    